<div>
  <div class="bottom-space">
    <button mat-stroked-button color="primary" type="button" (click)="onClick()">
      {{text}}
    </button>
  </div>
  <div>
    @if (!selected ) {
      <mat-error> Please select a file</mat-error>
    }
    @for (file of files; track file) {
      <div class="bofa--heading is-8 bold ">
        <mat-chip-listbox #chipList aria-label="File selection">
          <mat-chip-option [selectable]="selectable">
            {{file.data.name}}
          </mat-chip-option>
        </mat-chip-listbox>
        @if (file.canRetry) {
          <mat-error class="top-space"> {{file.error}}</mat-error>
        }
      </div>
    }
  </div>
</div>

<div class="flex-container">
  <div class="fx-flex-85">
    <ul class="padd-15">
      @for (file of files; track file) {
        <li>
          <mat-progress-bar class="bottom-space" [value]="file.progress"></mat-progress-bar>
          @if (file.canRetry) {
            <button class="bofa--button secondary outlined" (click)="retryFile(file)">
              Retry upload
            </button>
          }
        </li>
      }
    </ul>
  </div>
</div>

<label for="fileUpload" class="bofa--skiplink">Upload file</label>
<input type="file" id="fileUpload" #fileUpload name="fileUpload" class="fileUpload"  />